document.addEventListener("DOMContentLoaded", () => {
  const addItemBtn = document.getElementById("add-item");
  const itemsTable = document.querySelector("#items-table-body");
  const orderTotalDisplay = document.getElementById("order-total");
  const itemTemplate = document.getElementById("item-template");

  function recalcRowTotal(row) {
    const unitCost = parseFloat(row.querySelector(".unit-cost")?.value) || 0;
    const qty = parseFloat(row.querySelector(".qty")?.value) || 0;
    const rowTotalField = row.querySelector(".row-total");
    const total = unitCost * qty;
    if (rowTotalField) rowTotalField.value = total.toFixed(2);
  }

  function recalcOrderTotal() {
    let sum = 0;
    itemsTable.querySelectorAll(".item-row").forEach(row => {
      const destroyFlag = row.querySelector(".destroy-flag");
      if (!destroyFlag || destroyFlag.value !== "1") {
        const rowTotalField = row.querySelector(".row-total");
        sum += parseFloat(rowTotalField?.value) || 0;
      }
    });
    if (orderTotalDisplay) orderTotalDisplay.textContent = sum.toFixed(2);
  }

  if (addItemBtn) {
    addItemBtn.addEventListener("click", () => {
      if (!itemTemplate) return;

      const newRowHtml = itemTemplate.innerHTML;
      const uniqueIndex = new Date().getTime();
      const rowHtml = newRowHtml.replace(/NEW_RECORD/g, uniqueIndex);

      const tempDiv = document.createElement("tbody");
      tempDiv.innerHTML = rowHtml.trim();
      const newRow = tempDiv.firstElementChild;

      newRow.querySelectorAll("input, select").forEach(input => {
        if (input.type === "text" || input.type === "number") input.value = "";
        if (input.classList.contains("destroy-flag")) input.value = "0";
      });

      itemsTable.appendChild(newRow);
    });
  }

  if (itemsTable) {
    itemsTable.addEventListener("click", (e) => {
      const removeLink = e.target.closest(".remove-item");
      if (removeLink) {
        const row = removeLink.closest("tr");
        const destroyFlag = row.querySelector(".destroy-flag");
        if (destroyFlag) {
          destroyFlag.value = "1";
          row.style.display = "none";
        } else {
          row.remove();
        }
        recalcOrderTotal();
      }
    });

    itemsTable.addEventListener("input", (e) => {
      const row = e.target.closest("tr");
      if (row && (e.target.classList.contains("unit-cost") || e.target.classList.contains("qty"))) {
        recalcRowTotal(row);
        recalcOrderTotal();
      }
    });

    itemsTable.querySelectorAll(".item-row").forEach(row => recalcRowTotal(row));
    recalcOrderTotal();
  }
});
